import { render, staticRenderFns } from "./FieldsPanel.vue?vue&type=template&id=0976706d&scoped=true"
import script from "./FieldsPanel.vue?vue&type=script&lang=js"
export * from "./FieldsPanel.vue?vue&type=script&lang=js"
import style0 from "./FieldsPanel.vue?vue&type=style&index=0&id=0976706d&prod&scoped=true&lang=css"
import style1 from "./FieldsPanel.vue?vue&type=style&index=1&id=0976706d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976706d",
  null
  
)

export default component.exports